import { API } from "aws-amplify";
import LocalizedStrings from "react-localization";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { useContext } from "react";

import MaintenanceRoutineForm from "components/maintenanceRoutines/MaintenanceRoutineForm";
import { createMaintenanceRoutine } from "graphql/mutations";
import { LayoutContext } from "layout/context/LayoutContext";

const MaintenanceRoutineCreateForm = ({ onSuccess }) => {
  const { me } = useContext(LayoutContext);
  const navigate = useNavigate();
  const maintenanceRoutine = {
    name: "",
    description: "",
    companyID: me.companyID ?? "",
  };

  async function onSubmit(valuesParam) {
    try {
      const { name, description, companyID } =
        valuesParam;

      await API.graphql({
        query: createMaintenanceRoutine.replaceAll("__typename", ""),
        variables: {
          input: {
            name,
            description,
            companyID,
          },
        },
      });

      toast.success(strings.successAdded);
      if (onSuccess) onSuccess();
      else navigate("/maintenance-routines");
    } catch (err) {
      toast.error(strings.responses[err]);
    }
  }

  return (
    <div>
      <MaintenanceRoutineForm onSubmit={onSubmit} initialValues={maintenanceRoutine} />
    </div>
  );
};

const strings = new LocalizedStrings({
  es: {
    title: "Agregar Rutina de Mantenimiento",
    successAdded: "Rutina de Mantenimiento agregada con éxito",
    responses: {},
  },
});

export default MaintenanceRoutineCreateForm;
